import { SortingRule } from 'react-table';
import { atom, selector } from 'recoil';
import { addDays } from 'date-fns';
import { AuditRequest, FilterOption, PaginationInfo } from '../../types';
import { GetAuditRequestsRequest } from '../../api';

export const outboundTrafficMonitorFiltersState = atom<FilterOption[]>({
  key: 'outboundTrafficMonitorFilters',
  default: [],
});

export const outboundTrafficMonitorStartDateState = atom<Date>({
  key: 'outboundTrafficMonitorStartDate',
  default: addDays(new Date(), -7),
});

export const outboundTrafficMonitorEndDateState = atom<Date>({
  key: 'outboundTrafficMonitorEndDate',
  default: new Date(),
});

export const outboundTrafficMonitorOrderByColumnState = atom<string | undefined>({
  key: 'outboundTrafficMonitorOrderByColumn',
  default: undefined,
});

export const outboundTrafficMonitorOrderByDescendingState = atom<boolean>({
  key: 'outboundTrafficMonitorOrderByDescending',
  default: false,
});

export const outboundTrafficMonitorPageSizeState = atom<number>({
  key: 'outboundTrafficMonitorPageSize',
  default: 10,
});

export const outboundTrafficMonitorPageNumberState = atom<number>({
  key: 'outboundTrafficMonitorPageNumber',
  default: 1,
});

export const outboundTrafficMonitorDirectionState = atom<string>({
  key: 'outboundTrafficMonitorDirectionState',
  default: 'Inbound',
});

export const outboundTrafficMonitorTextSearchState = atom<string>({
  key: 'outboundTrafficMonitorTextSearchState',
  default: '',
});

export const outboundTrafficMonitorDataState = atom<AuditRequest[] | undefined>({
  key: 'outboundTrafficMonitorDataState',
  default: undefined,
});

export const outboundTrafficMonitorPaginationState = atom<PaginationInfo | undefined>({
  key: 'outboundTrafficMonitorPaginationState',
  default: undefined,
});

export const outboundTrafficMonitorSortByState = selector<SortingRule<AuditRequest>[]>({
  key: 'outboundTrafficMonitorSortBy',
  get: ({ get }) => {
    const orderByColumn = get(outboundTrafficMonitorOrderByColumnState);
    const orderByDescending = get(outboundTrafficMonitorOrderByDescendingState);
    return orderByColumn ? [{ id: orderByColumn, desc: orderByDescending }] : [];
  },
});

export const outboundTrafficMonitorRequestState = selector<GetAuditRequestsRequest>({
  key: 'outBoundAuditRequestsRequest',
  get: ({ get }) => {
    const sortByDesc = get(outboundTrafficMonitorOrderByDescendingState);
    const sortByColumn = get(outboundTrafficMonitorOrderByColumnState);

    const request = {
      keyword: get(outboundTrafficMonitorTextSearchState),
      startDate: get(outboundTrafficMonitorStartDateState)?.toISOString() ?? '',
      endDate: get(outboundTrafficMonitorEndDateState).toISOString() ?? '',
      apiCall:
        get(outboundTrafficMonitorFiltersState).filter((x) => x.name === 'apiCall')[0]
          ?.selectedItems[0]?.value ?? '',
      status:
        get(outboundTrafficMonitorFiltersState).filter((x) => x.name === 'status')[0]
          ?.selectedItems[0]?.value ?? '',
      httpCode:
        get(outboundTrafficMonitorFiltersState).filter((x) => x.name === 'httpCode')[0]
          ?.selectedItems[0]?.value ?? '',
      pageSize: get(outboundTrafficMonitorPageSizeState),
      pageNumber: get(outboundTrafficMonitorPageNumberState),
      ...(sortByColumn && {
        sortByValue: sortByColumn,
        sortBy: sortByDesc ? 'Descending' : 'Ascending',
      }),
    } as unknown as GetAuditRequestsRequest;

    get(outboundTrafficMonitorFiltersState).forEach((filter) => {
      if (!filter.isSearchText) {
        request[filter.name] = filter.selectedItems.map((selected) => selected.value);
      }
    });

    return request;
  },
});
